import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  KIMENŐ LEVELEZÉS BEÁLLÍTÁSA.
 *
 *  A levélküldő adatai eddig a telepítés környezeti változóiban éltek, beégetett
 *  tartalékkal. Ahol nem voltak kitöltve, a rendszer csendben egy idegen
 *  kiszolgálóra próbált küldeni, a hitelesítés elbukott, és a felületen semmi nem
 *  árulta el, miért nem érkezik meg például az ebédrendelés levele.
 *
 *  Ezért van itt PRÓBALEVÉL is: a kapcsolat-ellenőrzés kevés, mert a szolgáltatók
 *  egy része a bejelentkezést elfogadja, a küldést viszont visszautasítja.
 */
@Component({
  selector: 'app-admin-smtp-beallitas',
  templateUrl: './smtp-beallitas.component.html',
  styleUrls: ['./smtp-beallitas.component.scss'],
})
export class AdminSmtpBeallitasComponent implements OnInit {
  toltodik = true;
  ment = false;
  tesztFut = false;
  probaFut = false;

  b: any = { host: '', port: 465, secure: true, felhasznalo: '', felado: '', valasz_cim: '', engedelyezve: true };
  jelszo = '';
  jelszoBeallitva = false;
  forras = '';
  modositva: string | null = null;

  probaCim = '';
  eredmeny: { ok: boolean; szoveg: string } | null = null;

  /*  Az S/MIME aláíró és a feladó eltérése némán karanténba tett leveleket okoz:
   *  a küldés hibátlan, a címzett mégsem kapja meg. Ezért látszania kell. */
  smime: any = { betoltve: false };
  figyelmeztetes: string | null = null;

  // Küldési napló: erre a kérdésre válaszol, hogy „sikeres volt, mégsem érkezett meg".
  naplo: any[] = [];
  naploNyitva = false;
  naploFut = false;

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() { await this.betolt(); }

  async betolt() {
    this.toltodik = true;
    try {
      const r: any = await firstValueFrom(this.http.get('/api/admin/smtp-beallitas'));
      this.b = {
        host: r?.host || '', port: r?.port || 465, secure: !!r?.secure,
        felhasznalo: r?.felhasznalo || '', felado: r?.felado || '',
        valasz_cim: r?.valasz_cim || '', engedelyezve: r?.engedelyezve !== false,
      };
      this.jelszoBeallitva = !!r?.jelszo_beallitva;
      this.forras = r?.forras || '';
      this.modositva = r?.modositva || null;
      this.smime = r?.smime || { betoltve: false };
      this.figyelmeztetes = r?.figyelmeztetes || null;
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A beállítás nem tölthető be.', 'error');
    } finally {
      this.toltodik = false;
    }
  }

  async mentes() {
    if (this.ment) return;
    this.ment = true;
    this.eredmeny = null;
    try {
      // Üres jelszó mező = marad a meglévő. A kiszolgáló sem küldi vissza soha.
      await firstValueFrom(this.http.put('/api/admin/smtp-beallitas',
        { ...this.b, jelszo: this.jelszo || undefined }));
      this.jelszo = '';
      this.data.sendToast('Mentve. Az új beállítás azonnal érvényes.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.ment = false;
    }
  }

  async teszt() {
    if (this.tesztFut) return;
    this.tesztFut = true;
    this.eredmeny = null;
    try {
      const r: any = await firstValueFrom(
        this.http.post('/api/admin/smtp-beallitas/teszt', {}));
      this.eredmeny = r?.ok
        ? { ok: true, szoveg: `A kapcsolat és a bejelentkezés rendben (${r.host}:${r.port}).` }
        : { ok: false, szoveg: r?.error || 'A kapcsolat nem sikerült.' };
    } catch (e: any) {
      this.eredmeny = { ok: false, szoveg: e?.error?.error || 'A kapcsolat nem sikerült.' };
    } finally {
      this.tesztFut = false;
    }
  }

  async proba() {
    if (this.probaFut || !this.probaCim.trim()) return;
    this.probaFut = true;
    this.eredmeny = null;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/admin/smtp-beallitas/proba',
        { cimzett: this.probaCim.trim() }));
      this.eredmeny = r?.ok
        ? { ok: true, szoveg: `A kiszolgáló ÁTVETTE a levelet a(z) ${this.probaCim.trim()} `
            + `címre. Válasza: ${r.valasz || 'rendben'}`
            + (r.azonosito ? ` · azonosító: ${r.azonosito}` : '')
            + '. Innentől a kézbesítés a szolgáltatón múlik – ha nem érkezik meg, '
            + 'ezzel az azonosítóval kerestesd meg a szolgáltató naplójában.' }
        : { ok: false, szoveg: r?.error || 'A küldés nem sikerült.' };
      if (r?.figyelmeztetes) this.figyelmeztetes = r.figyelmeztetes;
      await this.naploBetolt();
    } catch (e: any) {
      this.eredmeny = { ok: false, szoveg: e?.error?.error || 'A küldés nem sikerült.' };
    } finally {
      this.probaFut = false;
    }
  }

  async naploValt() {
    this.naploNyitva = !this.naploNyitva;
    if (this.naploNyitva) await this.naploBetolt();
  }

  async naploBetolt() {
    this.naploFut = true;
    try {
      this.naplo = await firstValueFrom(
        this.http.get<any[]>('/api/admin/smtp-beallitas/naplo?db=30')) || [];
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A küldési napló nem tölthető be.', 'error');
    } finally {
      this.naploFut = false;
    }
  }

  naploSzin(statusz: string): string {
    if (statusz === 'hiba') return 'danger';
    if (statusz === 'reszleges') return 'warning';
    return 'success';
  }

  naploCimke(statusz: string): string {
    if (statusz === 'hiba') return 'nem ment ki';
    if (statusz === 'reszleges') return 'részben elutasítva';
    return 'átvette';
  }
}
